/** Ruhet në DB/API si «chint»; në UI përdoret «Energy Meter». */

export const EM_BRAND_CHINT_API = 'chint';
export const EM_BRAND_CHINT_LABEL = 'Energy Meter';

export function energyMeterBrandFromApi(brand) {
  const b = String(brand ?? '').trim().toLowerCase();
  if (b === EM_BRAND_CHINT_API) return EM_BRAND_CHINT_LABEL;
  return String(brand ?? '').trim();
}

export function energyMeterBrandToApi(brand) {
  const raw = String(brand ?? '').trim();
  const lower = raw.toLowerCase();
  if (lower === EM_BRAND_CHINT_LABEL.toLowerCase()) return EM_BRAND_CHINT_API;
  if (lower === EM_BRAND_CHINT_API) return EM_BRAND_CHINT_API;
  return raw;
}

export function isEnergyMeterChintProfile(brand) {
  const lower = String(brand ?? '').trim().toLowerCase();
  return lower === EM_BRAND_CHINT_API || lower === EM_BRAND_CHINT_LABEL.toLowerCase();
}

/** Tekst për UI (model etj.): fjala «Chint» → «Energy Meter». */
export function formatEnergyMeterChintNamingForDisplay(text) {
  if (text == null) return '';
  const s = String(text);
  if (!s.trim()) return s;
  if (s.trim().toLowerCase() === EM_BRAND_CHINT_API) return EM_BRAND_CHINT_LABEL;
  return s.replace(/\bchint\b/gi, EM_BRAND_CHINT_LABEL);
}

/** Dokument meter nga API (brand/model/modbus_profile) — njëjtë logjikë si në EnergyMeterDetail. */
export function isChintEnergyMeterRecord(meter) {
  if (!meter || typeof meter !== 'object') return false;
  const model = String(meter.model ?? '').toLowerCase();
  const brand = String(meter.brand ?? '').toLowerCase();
  const profile = String(meter.modbus_profile ?? '').toLowerCase();
  return model.includes('chint') || brand.includes('chint') || profile.includes('chint');
}

/**
 * Rruga e faqes së detajit të EMS (`/devices/.../energy-meter/:id` ose `.../chint` për profilin Chint).
 * `meter.data_logger_id` bosh → segment `standalone`.
 */
export function buildEnergyMeterDetailPath(meter) {
  if (!meter || meter.id == null || String(meter.id).trim() === '') return null;
  const rawDl = meter.data_logger_id;
  const dlSeg =
    rawDl != null && String(rawDl).trim() !== ''
      ? encodeURIComponent(String(rawDl).trim())
      : 'standalone';
  const suffix = isChintEnergyMeterRecord(meter) ? '/chint' : '';
  return `/devices/${dlSeg}/energy-meter/${encodeURIComponent(String(meter.id).trim())}${suffix}`;
}
